{
	"back": "Back to the ranking",
	"card": {
		"answer": "Answer given",
		"candidate": "Candidate",
		"candidate_none": "The application is not in the version in force.",
		"candidate_outcome": "Outcome: {{outcome}}",
		"candidate_position": "Position {{position}} in the {{list}} list, score {{score}}, version {{number}}",
		"closed_by": "Closed by {{name}} on {{when}}",
		"closed_by_unknown": "Closed on {{when}}",
		"fact": "Fact recorded: {{fact}}",
		"file": "Attached document",
		"file_failed": "We could not open the document. Try again.",
		"open_application": "Open the application",
		"text": "What the student says",
		"text_erased": "The text is gone: the student asked for their data to be erased.",
		"title": "Report",
		"version": "The student was reading version {{number}} of the ranking."
	},
	"close": {
		"choice": "How do you close it?",
		"correct_transcription": "Correct the transcription",
		"corrected": "Record a correction",
		"corrected_hint": "The fact that changes something is already recorded: you choose it below.",
		"done": "Report closed.",
		"errors": {
			"already_closed": "A colleague already closed it: read their answer.",
			"default": "We could not close the report. Try again.",
			"fact_invalid": "That fact is not of this application, comes before the report or did not change its row in the ranking. Choose another or close with no correction."
		},
		"fact_choice": "Facts recorded on this application after the report",
		"fact_intro": "Record the fact that produced the correction first. Then choose it here.",
		"fact_none": "No fact recorded after the report changed the row of this application in the ranking: you cannot close it as corrected.",
		"fact_required": "Choose the fact that produced the correction.",
		"intro": "A report is not an appeal and no position is changed here: if something has to be corrected, record the fact first with the tools that already exist.",
		"no_change": "No correction due",
		"no_change_hint": "The detail is right or the ranking is correct as it is.",
		"open_flags": "Open the requirement flags",
		"response": "Answer to the student",
		"response_hint": "They read it in their area. At least {{min}} characters.",
		"response_required": "Write at least {{min}} characters.",
		"send": "Close the report",
		"title": "Close the report"
	},
	"empty_closed": "No closed reports.",
	"empty_open": "No open reports.",
	"fact_line": "{{type}} · {{subject}} · {{when}}",
	"fact_type": {
		"application_submission_correction": "Correction of the transcription",
		"requirement_flag": "Requirement flag closed"
	},
	"filters": {
		"closed": "Closed",
		"open": "Open"
	},
	"list": {
		"doctoral": "Doctoral and specialization students",
		"freshers": "Matricole",
		"later_years": "Later years"
	},
	"outcome": {
		"assigned": "place assigned",
		"excluded": "excluded: another application counts",
		"forfeited": "forfeited: declined, offer lapsed, excluded at the verification or contract not signed",
		"no_seat": "no place",
		"not_admitted": "not admitted",
		"withdrawn": "withdrawn: accepted a place in another residence"
	},
	"page_title": "Errors reported by students",
	"row": {
		"protocol": "Protocol {{protocol}}",
		"sent": "Sent on {{when}}",
		"version": "Version {{number}}",
		"with_file": "With a file"
	},
	"state": {
		"closed_corrected": "Closed, correction recorded",
		"closed_no_change": "Closed, no correction",
		"open": "Open"
	},
	"type": {
		"my_data_wrong": "One of my details is wrong",
		"my_position_wrong": "My position does not look right",
		"other": "Other"
	}
}
